;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Model = APP.module('Model');

	Model.AccountBuilder = Model.AccountBuilder.extend({
		defaults: {
				widgets: [ 'MenuSideBar','Promo'],
				form_templates: 'Clubs_',
				regions: [
					{ id: 'account', name: 'Your details', url: 'account'},
					{ id: 'changePassword', name: 'Change Password', url: 'account/change_password'},
					{ id: 'notifications', name: 'Communications', url: 'account/notifications'},
					{ id: 'contactUs', name: 'Contact us', url: 'help/contact-us'}
				],
				menuItems: [
					{ name: 'Your details', url: 'account', status: ''},
					{ name: 'Change Password', url: 'account/change_password', status: ''},
					{ name: 'Communications', url: 'account/notifications', status: ''},
					{ name: 'Contact us', url: 'help/contact-us', status: ''}
				],
				//if error try to check if custom checkbox enabled
				your_details_fields: 'avatar,team_name,team_supported,first_name,last_name,email,country,state,postcode,mobile,birthday',
				notification_fields : {
					global: 'disable_notifications',
					others: 'news,weekly_results,weekly_reminders'
				},
				socialConnect: {
					facebook: true,
					twitter: false
				}
		}
	});

}(window, APP, Backbone, Marionette, $, _));